import axios from 'axios';
import Qs from 'qs';

const REQ_TIMEOUT = 7000;
const ROUTES = {
    getProducts: 'get_products',
    getDepositRates: 'get_deposit_rates',
    getLoanRates: 'get_loan_rates',
    getLoanInsuranceRates: 'get_loan_insurance_rates',
};

const RATE_FUNC_NAMES = {
    deposit: 'getDepositRatesByProductId',
};

export default {
    /**
     * @param {string} endpoint
     * @return {Promise}
     */
    init(endpoint) {
        this.axios = this.newAxios();

        return this.axios.get(endpoint).then((response) => this.setupRoutes(response.data));
    },

    /**
     * @param {Object} params
     * @return {Promise}
     */
    getProducts(params) {
        return this.axios.get(this.expandUrl(ROUTES.getProducts), params);
    },

    /**
     * @param {string} productId
     * @returns {Promise}
     */
    getDepositRatesByProductId(productId) {
        const params = {
            params: { filters: { depositIds: productId } },
        };

        return this.axios.get(this.expandUrl(ROUTES.getDepositRates), params);
    },

    /**
     * @param {Object} routes
     */
    setupRoutes(routes) {
        this.routes = routes;
    },

    /**
     * @returns {AxiosInstance}
     */
    newAxios() {
        return axios.create({
            timeout: REQ_TIMEOUT,
            paramsSerializer: function (params) {
                return Qs.stringify(params, { arrayFormat: 'brackets' });
            },
            withCredentials: true,
        });
    },

    /**
     * @param {string} route
     * @returns {string}
     */
    expandUrl(route) {
        return this.routes[route];
    },

    /**
     * @param {string} endpoint
     * @param {string} gpcCode
     * @param {string} lpcCode
     * @param {string} productType
     * @return {Promise}
     */
    getProductRates({ endpoint, gpcCode, lpcCode, productType }) {
        if (productType === 'dummy') {
            // for testing purposes dummy-*.js may be used instead of rates form api call:
            return Promise.resolve({
                data: {
                    data: [require('../../dummy-data/deposit/different-terms').default],
                },
            });
        }

        const productParam = {
            params: {
                filters: {
                    gpcCodeId: gpcCode,
                    lpcCodeId: lpcCode,
                },
            },
        };

        return this.init(endpoint)
            .then(() => this.getProducts(productParam))
            .then((response) => {
                if (response.status === 200 && response.data.success && response.data.meta.count > 0) {
                    return this[RATE_FUNC_NAMES[productType]](response.data.data[0][0].id);
                }
                return null;
            })
            .catch((error) => {
                console.log(error);
                return null;
            });
    },

    /**
     * @param {string} endpoint
     * @param {number} cityId
     * @return {Promise}
     */
    getLoanRates({ endpoint, cityId }) {
        const loanRateParam = {
            params: {
                filters: {
                    cityId: cityId,
                },
            },
        };

        return this.init(endpoint)
            .then(() =>
                Promise.all([
                    this.axios.get(this.expandUrl(ROUTES.getLoanInsuranceRates)),
                    this.axios.get(this.expandUrl(ROUTES.getLoanRates), loanRateParam),
                ])
            )
            .catch((error) => {
                console.log(error);
                return null;
            });
    },
};
